// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2pxIE","register":"styles_register__2tg5m","form":"styles_form__z9bcX","actions":"styles_actions__3rFya"};